function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var toastCacheMap = {};
/**
 * toast的缓存策略，做一个简单的管理，防止多个相同的toast一直创建叠加，如果有相同的text，不做任何处理
 */

export function cacheToaster(obj, method) {
  var originMethod = obj[method];

  obj[method] = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      text: ''
    };

    if (!toastCacheMap[method]) {
      toastCacheMap[method] = {};
    }

    if (!toastCacheMap[method][props.text]) {
      toastCacheMap[method][props.text] = true;
      return originMethod(_objectSpread(_objectSpread({}, props), {}, {
        onCancel: function onCancel() {
          var _props$onCancel;

          toastCacheMap[method][props.text] = false;
          (_props$onCancel = props.onCancel) === null || _props$onCancel === void 0 ? void 0 : _props$onCancel.call(props);
        }
      }));
    }
  };
}